module.exports = __webpack_public_path__ + "img/close_popup.5e0148ed.svg";